import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArTD: CultureInfo = {
  name: 'ar-TD',
  displayName: 'العربية (تشاد)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-TD',
  parent: CultureInfoAr
};
